<template>
    <div class="bg-gray-100">
        <TopLocationHero title-key="visitor_center.title" static-image-key="visitor-center___hero" />

        <div class="relative mt-4 sm:mt-12 z-1">
            <a id="main-content" class="fixed top-0" tabindex="-1"></a>

            <div class="container hidden sm:block">
                <Breadcrumb :items="breadcrumbItems" />
            </div>

            <TopLocationBackgroundShape1 />
        </div>

        <div class="container relative z-2 mt-12">
            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- INTRO -->
            <!-- * -->
            <Type6Block
                title-key="visitor_center.intro.title"
                featured
                description-key="visitor_center.intro.description"
                :images="galleryImages2"
            />

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- TELL US YOUR OPINION -->
            <!-- * -->
            <Type3Block
                title-key="visitor_center.feedback.title"
                description-key="visitor_center.feedback.description"
                class="mt-16 sm:mt-20"
                static-image-key="visitor-center___feedback"
            />

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- TIME TRAVEL ON THE SCALE MODEL -->
            <!-- * -->
            <Type8Block
                title-key="visitor_center.scale_model.title"
                description-key="visitor_center.scale_model.description"
                class="mt-16 sm:mt-20"
            />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- STATS -->
        <!-- * -->
        <div
            class="bg-cover bg-center relative mt-16 sm:mt-20"
            :style="`background-image: url(${require('~/assets/images/dev/makett.jpg')})`"
        >
            <div class="absolute top-0 left-0 w-full h-full" style="background: rgba(0, 0, 0, 0.75)"></div>
            <div class="container relative py-12">
                <div class="grid grid-cols-1 lg:grid-cols-3 base-responsive-gap text-white">
                    <div>
                        <div class="pb-8 lg:pb-16">
                            <div class="header-2 mb-8 uppercase"><T t="visitor_center.stats.title" /></div>
                            <div class="font-Poppins font-semibold text-xl lg:text-3xl">
                                <T t="visitor_center.stats.lead" />
                            </div>
                        </div>
                        <div class="py-4 lg:py-8 border-t border-white">
                            <div>
                                <span class="display">42</span
                                ><span class="scale-model-label"><T t="visitor_center.stats.stat_1.label" /></span>
                            </div>
                            <p class="mt-2">
                                <T t="visitor_center.stats.stat_1.description" />
                            </p>
                        </div>
                        <div class="py-4 lg:py-8 lg:pb-0 border-t border-white">
                            <div>
                                <span class="display">7000</span
                                ><span class="scale-model-label"><T t="visitor_center.stats.stat_2.label" /></span>
                            </div>
                            <p class="mt-2">
                                <T t="visitor_center.stats.stat_2.description" />
                            </p>
                        </div>
                    </div>

                    <div>
                        <div class="py-4 lg:py-8 border-t lg:border-none border-white">
                            <div>
                                <span class="display">4</span>
                                <span class="scale-model-label">
                                    <T t="visitor_center.stats.stat_3.label" />
                                </span>
                            </div>
                            <p class="mt-2">
                                <T t="visitor_center.stats.stat_2.description" />
                            </p>
                        </div>
                        <div class="py-4 lg:py-8 border-t border-white">
                            <div>
                                <span class="display">3.5</span>
                                <span class="scale-model-label">
                                    <T t="visitor_center.stats.stat_4.label" />
                                </span>
                            </div>
                            <p class="mt-2">
                                <T t="visitor_center.stats.stat_4.description" />
                            </p>
                        </div>
                        <div class="py-4 lg:py-8 lg:pb-0 border-t border-white">
                            <div>
                                <span class="display">3D</span>
                                <span class="scale-model-label">
                                    <T t="visitor_center.stats.stat_5.label" />
                                </span>
                            </div>
                            <p class="mt-2">
                                <T t="visitor_center.stats.stat_5.description" />
                            </p>
                        </div>
                    </div>
                    <div>
                        <div class="py-4 lg:py-8 border-t lg:border-none border-white">
                            <div>
                                <span class="display">6.398</span>
                                <span class="scale-model-label">
                                    <T t="visitor_center.stats.stat_6.label_1" />
                                </span>
                            </div>
                            <div>
                                <span class="display">8.028</span>
                                <span class="scale-model-label">
                                    <T t="visitor_center.stats.stat_6.label_2" />
                                </span>
                            </div>
                            <div class="lg:pl-[5.25rem] xl:pl-[9.375rem]">
                                <span class="display">4</span>
                                <span class="scale-model-label">
                                    <T t="visitor_center.stats.stat_6.label_3" />
                                </span>
                            </div>
                            <p class="mt-2">
                                <T t="visitor_center.stats.stat_6.description" />
                            </p>
                        </div>
                        <div class="py-4 lg:py-8 border-t border-white">
                            <div>
                                <span class="display">86</span
                                ><span class="scale-model-label"><T t="visitor_center.stats.stat_7.label" /></span>
                            </div>
                            <p class="mt-2">
                                <T t="visitor_center.stats.stat_7.description" />
                            </p>
                        </div>
                    </div>

                    <div class="lg:col-span-2 lg:col-start-2 lg:mt-2">
                        <p>
                            <T t="visitor_center.stats.info" />
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- GALLERY -->
        <!-- * -->
        <XXLGalleryCarousel v-if="galleryImages1" :images="galleryImages1" class="mt-16 sm:mt-20" />

        <div class="container mt-16 sm:mt-20">
            <TopLocationProjectPageBanner
                v-if="$t('visitor_center.event_recommendation_button_url').length"
                :button-text="$t('visitor_center.event_recommendation_button_label')"
                :button-url="$t('visitor_center.event_recommendation_button_url')"
                label-text-key="visitor_center.event_recommendation_text"
                type="event"
            />

            <TopLocationProjectPageBanner
                :button-text="$t('visitor_center.visit_project_button_label')"
                :button-url="$t('visitor_center.visit_project_button_url')"
                label-text-key="visitor_center.visit_project_text"
                class="mt-4 sm:mt-8"
            />

            <AwardsBlock
                v-if="awards"
                :title="awards.title"
                :description="awards.description"
                :media="awards.media"
                class="mt-16 sm:mt-20"
            />
        </div>
    </div>
</template>

<script>
import TopLocationProjectPageBanner from '@/components/Pages/TopLocation/TopLocationProjectPageBanner.vue';
import AwardsBlock from '@/components/Blocks/AwardsBlock/AwardsBlock.vue';
import TopLocationHero from '@/components/Pages/TopLocation/Hero/Hero.vue';
import Type3Block from '@/components/Blocks/Type3Block/Type3Block.vue';
import Type6Block from '@/components/Blocks/Type6Block/Type6Block.vue';
import Type8Block from '@/components/Blocks/Type8Block/Type8Block.vue';
import XXLGalleryCarousel from '@/components/Carousels/XXLGalleryCarousel/XXLGalleryCarousel.vue';
import TopLocationBackgroundShape1 from '@/components/Pages/TopLocation/TopLocationBackgroundShape1.vue';

export default {
    name: 'LigetBudapestVisitorCenter',
    components: {
        AwardsBlock,
        TopLocationProjectPageBanner,
        TopLocationBackgroundShape1,
        TopLocationHero,
        Type3Block,
        Type6Block,
        Type8Block,
        XXLGalleryCarousel,
    },
    async asyncData({ $axios, i18n }) {
        let galleryImages1 = null;
        let galleryImages2 = null;
        let awards = null;

        await Promise.allSettled([
            $axios.$get('/galleries/reference/top-location___visitor-center-1'),
            $axios.$get('/galleries/reference/top-location___visitor-center-2'),
            $axios.$get('/awards/reference/visitor-center'),
        ])
            .then(([galleryImages1Res, galleryImages2Res, awardsRes]) => {
                if (galleryImages1Res.status === 'fulfilled') {
                    galleryImages1 = galleryImages1Res.value.slides;
                }

                if (galleryImages2Res.status === 'fulfilled') {
                    galleryImages2 = galleryImages2Res.value.slides;
                }

                if (awardsRes.status === 'fulfilled' && awardsRes.value.is_on_top_locations) {
                    awards = awardsRes.value;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('navigation.top_locations'), 'top-locations', true]);
        breadcrumbItems.push([i18n.t('visitor_center.title'), 'city-park-visitor-center']);

        return {
            galleryImages1,
            galleryImages2,
            breadcrumbItems,
            awards,
        };
    },
    data() {
        return {};
    },
    head() {
        return {
            title: this.$getPageTitle('top-locations.visitor-center'),
            meta: this.$getPageMetaData('top-locations.visitor-center'),
        };
    },
};
</script>

<style scoped>
.scale-model-label {
    @apply font-Poppins font-semibold text-2xl sm:text-3xl lg:text-4xl xl:text-6xl ml-3;
}
</style>
